import React, { PropTypes } from 'react';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import _ from 'lodash';
import {apiRoutes} from 'app/globals';
import PureRenderComponent from 'app/lib/PureRenderComponent';
import { CollapsibleItem, Col, Row } from 'routes/app/components';
import { ImportIcon, ExportIcon } from 'routes/app/components/SvgIcon';
import Modal from 'routes/app/components/Modal';
import Button from 'routes/app/components/Button';
import Table from 'routes/app/components/Table';
import Icon from 'routes/app/components/Icon';
import UnitReasons from '../UnitReasons/UnitReasons';

import './style.scss';

class Unit extends PureRenderComponent {

    static propTypes = {
        index: PropTypes.number,
        unit: PropTypes.object,
        getGoods: PropTypes.func,
        intl: intlShape
    };

    renderUnitHeader(unit) {
        return (
            <div className="unit__header">
                {unit.status.trim().toLowerCase() === 'rejected' &&
                    <Icon className="unit__header__error">error_outline</Icon>
                }
                <i className="icon">
                    {unit.inOut === 'O' ?
                        <ExportIcon />
                    :
                        <ImportIcon />
                    }
                </i>
                <small className="unit__header__type"><FormattedMessage id={`unit.empty.${unit.empty}`} /></small>
                <small className="unit__header__trac"><strong><FormattedMessage id="unit.trac" />:</strong> {unit.trac} </small>
                {unit.reference && <small className="unit__header__ref"><strong><FormattedMessage id="unit.ref" />:</strong> {unit.reference}</small>}
                {unit.ctNumber && <small><strong><FormattedMessage id="unit.ctNumber" />:</strong> {unit.ctNumber}</small>}
            </div>
        );
    }

    renderUnitBody(unit) {
        const {formatMessage} = this.props.intl;

        return (
            <div className="unit__body">
                <Row>
                    <Col s={12} m={unit.reasons.length ? 8 : 12}>
                        <div><FormattedMessage id={`unit.type.${unit.inOut.toLowerCase()}`} /></div>
                        <div><strong><FormattedMessage id="unit.trac" />:</strong> {unit.trac}</div>
                        {unit.reference && <div><strong><FormattedMessage id="unit.ref" />:</strong> {unit.reference}</div>}
                        {unit.ctNumber && <div><strong><FormattedMessage id="unit.ctNumber" />:</strong> {unit.ctNumber}</div>}
                        {unit.unitKind && <div><strong><FormattedMessage id="unit.unitKind" />:</strong> {unit.unitKind.desc}</div>}
                        {unit.pos && <div><strong><FormattedMessage id="unit.pos" />:</strong> <FormattedMessage id={`unit.pos.${unit.pos}`} /></div>}

                        {unit.empty === '0' ?
                            <div>
                                {unit.netto && <div><strong><FormattedMessage id="unit.netto" />:</strong> {unit.netto} kg</div>}

                            </div> : null}

                        <div><strong><FormattedMessage id="unit.rid" />:</strong> <FormattedMessage id={unit.rid ? 'label_yes' : 'label_no'} /></div>
                        <div><strong><FormattedMessage id="unit.dim" />:</strong> {unit.dim.desc}</div>
                    </Col>

                    {unit.reasons.length ?
                        <Col s={12} m={4}>
                            <UnitReasons reasons={unit.reasons} />
                        </Col> : null
                    }
                </Row>
                {unit.goods && <div className="unit__goods">
                    <strong><FormattedMessage id="unit.heading.goodsOverview"/>:</strong>
                    <ul>
                        {unit.goods.map((good, i) => (
                            <li key={i}>
                                <Modal
                                    trigger={<Button className="unit__goods__view" icon="visibility" flat/>}
                                    textDisagree={formatMessage({id:'button.close'})} agreeElement=" ">
                                    <Table><tbody>
                                        <tr><td><strong>{formatMessage({id:'good.label.description'})}</strong></td><td>{good.desc}</td></tr>
                                        <tr><td><strong>{formatMessage({id:'good.label.netWeight'})}</strong></td><td>{good.nettoWeight} kg</td></tr>
                                        <tr><td><strong>{formatMessage({id:'good.label.packagingID'})}</strong></td><td>{good.packagingId}</td></tr>
                                        <tr><td><strong>{formatMessage({id:'good.label.packagingCount'})}</strong></td><td>{good.packagingCount}</td></tr>
                                        <tr><td><strong>{formatMessage({id:'good.label.numPackIdUnit'})}</strong></td><td>{good.packagingUnity}</td></tr>
                                        <tr><td><strong>{formatMessage({id:'good.label.colliID'})}</strong></td><td>{good.colliId}</td></tr>
                                        <tr><td><strong>{formatMessage({id:'good.label.hazardous'})}</strong></td><td>{formatMessage({id:good.hzd ? 'label_yes' : 'label_no'})}</td></tr>
                                        </tbody>

                                        {good.hzd ?
                                        <tbody className="unit__good__modal--hzd">
                                            <tr><td><strong>{formatMessage({id:'good.label.rid'})}</strong></td><td>{good.hzdData.ridReg}</td></tr>
                                            <tr><td><strong>{formatMessage({id:'good.label.id'})}</strong></td><td>{good.hzdData.ridId}</td></tr>
                                            <tr><td><strong>{formatMessage({id:'good.label.unnr'})}</strong></td><td>{good.hzdData.unNr}</td></tr>
                                            <tr><td><strong>{formatMessage({id:'good.label.cls'})}</strong></td><td>{good.hzdData.cls}</td></tr>
                                            <tr><td><strong>{formatMessage({id:'good.label.packingGroup'})}</strong></td><td>{good.hzdData.packingGroup}</td></tr>
                                            <tr><td><strong>{formatMessage({id:'good.label.limitedQuantities'})}</strong></td><td>{formatMessage({id:good.hzdData.lq ? 'label_yes' : 'label_no'})}</td></tr>
                                            <tr><td><strong>{formatMessage({id:'good.label.maritime'})}</strong></td><td>{formatMessage({id:good.hzdData.maritime ? 'label_yes' : 'label_no'})}</td></tr>
                                            <tr><td><strong>{formatMessage({id:'good.label.env'})}</strong></td><td>{formatMessage({id:good.hzdData.environment ? 'label_yes' : 'label_no'})}</td></tr>
                                            <tr><td><strong>{formatMessage({id:'good.label.waste'})}</strong></td><td>{formatMessage({id:good.hzdData.waste ? 'label_yes' : 'label_no'})}</td></tr>
                                            </tbody> : null}
                                    </Table>
                                </Modal>
                                {good.hzd && <FormattedMessage id="good.label.hazardous" />} {good.desc} ({good.nettoWeight} kg)
                            </li>
                        ))}
                    </ul>
                </div>}

                {unit.docs && unit.docs.length > 0 && <div className="unit__goods">
                    <strong><FormattedMessage id="unit.heading.docsOverview"/>:</strong>
                    <ul>
                        {unit.docs.map((doc, i) => (
                            <li key={i}>
                                {doc.type}
                                {doc.number ? <span>, {doc.number}</span> : null}
                                {doc.regPlace ? <span>, {doc.regPlace}</span> : null}
                                {doc.regDate ? <span>, {doc.regDate}</span> : null}
                                {doc.attachments && doc.attachments.length > 0 && <ul>
                                    {doc.attachments.map((file) => (
                                        <li key={file.id}><a href={apiRoutes.DOWNLOAD_FILE({id:file.id})} target="_blank">{file.filename}</a></li>
                                    ))}
                                </ul>}
                            </li>
                        ))}
                    </ul>
                </div>}

            </div>
        );
    }

    render() {

        let {unit, index, getGoods, getDocs, ...props} = this.props;

        return (
            <CollapsibleItem header={this.renderUnitHeader(unit)}
                             eventKey={index} key={index}
                             onOpen={(vtrac)=>unit.empty === '0' && getGoods({trac:unit.trac}) && getDocs({trac:unit.trac})}>
                {this.renderUnitBody(unit)}
            </CollapsibleItem>
        );
    }

}

export default injectIntl(Unit);
